import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import loandetail from "../assets/loan detail.png";
import { Fade } from "@mui/material";
import FeaturesSection from "./FeaturesSection";
import { Slide } from "@mui/material";
import HeroSection from "./HeroSection";

const AboutSection = () => {
  return (

    <Slide direction="up" in={true} timeout={500}>
    <Container
      maxwidth={false}
      sx={{
        maxwidth: "1300px",
        marginTop: { xs: "0px", sm: "80px", lg: "50px" },
        marginBottom: { xs: "5px", sm: "80px", lg: "0px" },
      }}>

<HeroSection/>


      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Ensure vertical stacking on smaller screens
          justifyContent: "center", // Center content vertically
          padding: { xs: "0px", sm: "20px" },
          margin: "0 auto", // Center the content horizontally
          marginBottom:{xs:'50px'}
        }}>
        <Grid container spacing={2} alignItems="center">
          {/* Right Column (Text) */}
          <Grid item xs={12} md={7} sx={{ order: { xs: 1, md: 1 } }}>
            <Typography variant="h6">About</Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              SAVA Loan
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: "20px" }}>
              Sava Loan is an online lending platform that aims to provide
              affordable financial services to African consumers and small
              businesses who have limited access to financial products from
              traditional banks.
            </Typography>

            <Typography variant="body1">
              SAVA Loan is powered by SAVA Tech Financial Services Limited, by
              fostering financial inclusion in Africa and improving loan
              services for Tanzanians, Sava-tech hopes to make a meaningful
              impact on the lives of many people in need of access to financial
              services.
            </Typography>

            <Box sx={{ width: "100%", display: { xs: "flex", sm: "block" } }}>
              <Button
                variant="contained" // Use a Material-UI contained button for emphasis
                color="primary" // Choose the primary color for the button
                onClick={() => window.open("https://web.sava.co.tz/registration", "_blank")}
                sx={{
                  padding: "5px 20px", // Customize padding
                  fontSize: "14px", // Adjust font size
                  borderRadius: "5px", // Optional rounded corners
                  marginTop: "20px",
                }}>
                Apply Now
              </Button>
            </Box>
          </Grid>

          {/* Left Column (Image) */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              order: { xs: 2, md: 2 },
            }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <Fade in={true} timeout={1000}>
                <img
                  src={loandetail}
                  alt="About"
                  style={{
                    width: "60%", // Ensure the image is responsive
                    height: "auto",
                    borderRadius: "8px", // Optional rounded corners
                  }}
                />
              </Fade>
            </Box>
          </Grid>
        </Grid>
      </Box>


      <FeaturesSection/>
    </Container>
    </Slide>
  );
};

export default AboutSection;
